import { render, staticRenderFns } from "./BookBtn.vue?vue&type=template&id=5d13f842&scoped=true&"
import script from "./BookBtn.vue?vue&type=script&lang=js&"
export * from "./BookBtn.vue?vue&type=script&lang=js&"
import style0 from "./BookBtn.vue?vue&type=style&index=0&id=5d13f842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13f842",
  null
  
)

export default component.exports